import { Text } from "@simplybusiness/mobius";
import { type QuoteCardHeaderProps } from "../../types";

export const HeaderUK = ({
  logo,
  insurerName,
  underWriterText,
}: QuoteCardHeaderProps) => {
  const logoAltText = insurerName
    ? `${insurerName} insurer logo`
    : "Provider logo";

  return (
    <div className="mobius-quote-card__header --is-uk">
      {logo && (
        <div className="mobius-quote-card__header-logo --is-uk">
          <img
            src={logo}
            alt={logoAltText}
            className="mobius-quote-card__header-logo --is-uk"
          />
        </div>
      )}
      {underWriterText && (
        <Text className="header__underwriter-text">
          <span>Underwritten by:</span>
          <br />
          <span>{underWriterText}</span>
        </Text>
      )}
    </div>
  );
};
